import { z } from 'zod';

export const ChatMessageSchema = z.object({
  role: z.enum(['user', 'assistant', 'system']),
  content: z.string().min(1, 'Message content cannot be empty'),
});

export type ChatMessage = z.infer<typeof ChatMessageSchema>;

export const CHAT_AGENT_DEFAULT_MAX_STEPS = 6;
export const CHAT_AGENT_MAX_STEPS_LIMIT = 12;

export const ChatAgentSettingsSchema = z.object({
  maxSteps: z
    .number()
    .int('Agent maxSteps must be an integer')
    .min(1, 'Agent maxSteps must be at least 1')
    .max(CHAT_AGENT_MAX_STEPS_LIMIT, `Agent maxSteps cannot exceed ${CHAT_AGENT_MAX_STEPS_LIMIT}`)
    .optional(),
});

export type ChatAgentSettings = z.infer<typeof ChatAgentSettingsSchema>;

export const ChatRequestSchema = z.object({
  messages: z.array(ChatMessageSchema).min(1, 'At least one message is required'),
  modelId: z.string().min(1).optional(),
  agent: ChatAgentSettingsSchema.optional(),
});

export type ChatRequest = z.infer<typeof ChatRequestSchema>;

export const ChatModelSchema = z.object({
  id: z.string(),
  canonicalId: z.string(),
  providerModelId: z.string(),
  displayName: z.string(),
  provider: z.string(),
  tier: z.string(),
  description: z.string().nullable(),
  capabilities: z.array(z.string()).default([]),
  tweetLimit: z.number().nullable().optional(),
});

export type ChatModel = z.infer<typeof ChatModelSchema>;

export const ChatModelsResponseSchema = z.object({
  success: z.boolean().optional(),
  defaultModelId: z.string().nullable().optional(),
  models: z.array(ChatModelSchema),
  isAdmin: z.boolean().optional(),
  hasModelSelection: z.boolean().optional(),
});

export type ChatModelsResponse = z.infer<typeof ChatModelsResponseSchema>;
